import React, { useEffect, useState } from "react";
import "./feedback.scss";
import { formatDate } from "../../../components/reusableComponent/DateFormat";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Tooltip, IconButton } from "@mui/material";
import { Loader } from "react-bootstrap-typeahead";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {
  useConfirmFeedbackMutation,
  useGetFeedbackQuery,
} from "../../../Services/inventory/Inventory";

const Feedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const { data, status, isLoading, refetch } = useGetFeedbackQuery({});
  const [trigger, { status: confirmStatus }] = useConfirmFeedbackMutation();

  useEffect(() => {
    setDataLoading(status === "pending");
  }, [status]);

  useEffect(() => {
    setLoading(confirmStatus === "pending");
  }, [confirmStatus]);

  useEffect(() => {
    if (data) {
      setFeedbacks(data?.data);
    }
  }, [data]);

  const toggleFeedbackVerification = async (review) => {
    const updatedObj = {
      ids: [review?.id],
      is_selected: !review?.is_selected, // toggle value
    };

    const response = await trigger(updatedObj);

    if (response?.data) {
      refetch();
    }
  };

  return (
    <div className="feedback-container">
      <h2 className="title">Top reviews from India</h2>

      {isLoading || dataLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="feedback_grid">
          {feedbacks?.map((review, index) => (
            <div key={index} className="review-card">
              <div className="review-header">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div className="avatar"></div>
                  <span className="username">{review?.customer?.name}</span>
                </div>
                <div>
                  <Tooltip
                    title={
                      review?.is_selected
                        ? "Click to mark as Unverified"
                        : "Click to mark as Verified"
                    }
                  >
                    <IconButton
                      onClick={() => toggleFeedbackVerification(review)}
                      sx={{ color: review?.is_selected ? "green" : "gray" }}
                    >
                      {loading ? (
                        <Loader />
                      ) : review?.is_selected ? (
                        <VerifiedIcon />
                      ) : (
                        <HourglassEmptyIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </div>
              </div>

              <div className="rating">
                <span>
                  {Array.from({ length: 5 }, (_, i) => (
                    <span
                      key={i}
                      className={i < review.rating ? "star filled" : "star"}
                    >
                      ★
                    </span>
                  ))}
                </span>
                <span style={{ color: "black", marginLeft: "10px" }}>
                  {review?.customer?.name}
                </span>
              </div>

              <div style={{ fontWeight: "600" }}>
                {capitalizeFirstLetter(review?.workshop?.name)}
              </div>

              <p className="review-title">{review.title}</p>

              <p className="meta">
                Reviewed in India on {formatDate(review.created_at)}
                <br />
                {review.verified && (
                  <span className="verified"> | Verified Purchase</span>
                )}
              </p>

              <div className="review-body">
                <p>{review?.feedback}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Feedback;
